<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header" style="padding-bottom: 10px">
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                <b-button class="float-sm-right" variant="outline-success btn-toolbar sa-margin-right" size="sm" title="Associa Fornitore" v-b-tooltip.hover @click="onClickAssocizioneFornitorePrincipale">
                    <b-icon icon="people-fill"></b-icon>
                    Associa Utente
                </b-button>
            </b-col>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fieldsFornitorePrincipale" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(actions)="{ item }">
                        <b-container>
                            <b-button size="sm" v-b-tooltip.hover title="Visualizza" variant="outline-secondary" @click="onClickViewFornitore(item)">
                                <font-awesome-icon icon="eye"></font-awesome-icon>
                            </b-button>
                            <b-button variant="outline-danger" @click="onDeleteAssociazione(item)">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <configurazioni-magazzino-fornitori-modal-edit-component ref="cmpConfigurazioniMagazzinoFornitoriModalEdit"></configurazioni-magazzino-fornitori-modal-edit-component>

        <magazzino-articoli-fornitori-modal-edit-component ref="cmpMagazzinoArticoliFornitoriModalEdit" :json-data-articolo="jsonDataArticolo" @saveAssociazione="onSaveAssociazione" />
    </div>
</template>

<script>
import MagazzinoArticoliFornitoriModalEditComponent from "./MagazzinoArticoliFornitoriModalEditComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ConfigurazioniMagazzinoFornitoriModalEditComponent from "./ConfigurazioniMagazzinoFornitoriModalEditComponent.vue";
// import ModalError from "../../../template/components/modal/components/ModalError.vue";
export default {
    name: "MagazzinoArticoliFornitoriListComponent",
    mixins: [UtilityMixin],
    components: { MagazzinoArticoliFornitoriModalEditComponent, ConfigurazioniMagazzinoFornitoriModalEditComponent },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        if (me.id != -1) {
            console.log("Entro nel if del mounted DI FORNITOREEEEEEEEEEEEEEEEEEEEEEEEEEE");
            me.loadDataArticoloMagazzino(me.id);
        }
        me.loadAssociazioniFornitori();
    },
    data() {
        return {
            // Paths
            pathResourceMagazzinoArticolo: "/magazzinoarticoli",
            pathResourceAssociazioniFornitori: "/magazzinofornitoriarticoli",
            // Dati
            id: null,
            jsonDataArticolo: {},
            // Paginazione
            currentPage: 1,
            perPage: 10,
            tblListaFornitoriKey: 0,
            // Liste
            items: [],
            // listaFornitori: [],
            fieldsFornitorePrincipale: [
                {
                    label: "*",
                    key: "index",
                    sortable: false,
                },
                {
                    label: "Ragione Sociale",
                    key: "ragioneSocialeFornitore",
                    sortable: false,
                },
                {
                    label: "Codice Fornitore",
                    key: "codiceFornitore",
                    sortable: false,
                },
                {
                    label: "Partita Iva",
                    key: "partitaIvaFornitore",
                    sortable: false,
                },
                {
                    label: "Prezzo",
                    key: "prezzoArticoloFornitore",
                    sortable: false,
                    formatter: (value) => {
                        return value ? `€ ${parseFloat(value).toFixed(2)}` : "";
                    },
                },
                {
                    label: "Fornitore Principale",
                    key: "fornitorePrincipale",
                    sortable: false,
                    formatter: (value) => {
                        return value ? "Sì" : "No";
                    },
                },
                {
                    label: "",
                    key: "actions",
                    class: "sa-table-column-action-double",
                },
            ],
        };
    },
    methods: {
        loadAssociazioniFornitori() {
            let me = this;
            let params = { idArticolo: me.id };
            UtilityMixin.methods.loadDataResources(me.pathResourceAssociazioniFornitori, params, me.loadAssociazioniFornitoriSuccess, me.loadAssociazioniFornitoriError);
        },

        loadAssociazioniFornitoriSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            console.log("Associazioni fornitori caricate:", me.items);
        },
        loadAssociazioniFornitoriError(error) {
            console.error("Errore caricamento associazioni fornitori:", error);
        },
        loadDataArticoloMagazzino(id) {
            let me = this;
            me.$emit("beforeLoadData");
            UtilityMixin.methods.loadDataResources(me.pathResourceMagazzinoArticolo + "/" + id, null, me.loadDataArticoloMagazzinoSuccess, me.loadDataArticoloMagazzinoError);
        },
        loadDataArticoloMagazzinoSuccess(response) {
            let me = this;

            me.$emit("afterLoadData");
            me.jsonDataArticolo = response.data.data;
        },
        loadDataArticoloMagazzinoError(response) {
            let me = this;
            me.$emit("afterLoadData");
            console.log(response);
        },
        onClickAssocizioneFornitorePrincipale() {
            let me = this;
            let idFornitoreAssociati = me.items.map((item) => item.idFornitore);
            let hasFornitorePrincipale = me.items.some((item) => item.fornitorePrincipale);
            // console.log("Ha già fornitore principale:", hasFornitorePrincipale);
            //console.log("log id fornitori: ", idFornitoreAssociati);

            me.$refs.cmpMagazzinoArticoliFornitoriModalEdit.show(me.id, idFornitoreAssociati, hasFornitorePrincipale);
        },
        onSaveAssociazione(response) {
            let me = this;
            console.log("Associazione salvata con successo:", response);
            me.loadAssociazioniFornitori();
        },
        onClickViewFornitore(item) {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoFornitoriModalEdit.show(item, true);
        },

        onDeleteAssociazione(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questa associazione?", {
                    title: "Eliminazione associazione",
                    buttonSize: "sm",
                    okTitle: "SI",
                    okVariant: "danger",
                    cancelTitle: "NO",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteAssociazione(item.id);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        deleteAssociazione(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResourceAssociazioniFornitori + "/" + id, null, me.onDeleteAssociazioneSuccess, me.onDeleteAssociazioneError);
        },
        onDeleteAssociazioneSuccess() {
            let me = this;
            me.loadAssociazioniFornitori();
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        onDeleteAssociazioneError() {
            let me = this;
            me.loadAssociazioniFornitori();
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
